import request from '@/utils/request'

// 查询
export function fetchList (data) {
  return request.post('/template/parameter/page', data)
}

// 查询
export function findByType (data) {
  return request.post('/template/parameter/findByType', data)
}

// 创建
export function create (data) {
  return request.post('/template/parameter/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/template/parameter/updateById', data)
}
// 删除
export function deleteById (id) {
  return request.get(`/template/parameter/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/template/parameter/delete/batch', {
    params: {
      ids
    }
  })
}
